<template>
	<inertia-head title="Stock Updates" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">TRC Couples Blogs</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">TRC Couples Blogs Management</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="mb-4">
			<form @submit.prevent="searchRecords">
				<div class="row">
					<div class="col-md-9 mb-4">
						<div class="input-group">
							<input v-model="form.search" type="text" id="search" name="search" class="form-control" placeholder="Search" />
							<span class="input-group-btn">
								<button
									type="submit"
									class="btn btn-secondary"
									:disabled="!form.isDirty || form.processing"
								>
									<i class="fa fa-search me-1"></i>Search
								</button>
							</span>
						</div>
					</div>
					<div class="col space-x-1 mb-4 text-end">
						<button type="button" @click="viewTRCCoupleBlogModal(0,'add')" class="btn btn-alt-primary">
							<i class="fa fa-plus me-1"></i>
							Add Content
						</button>
					</div>
				</div>
			</form>
		</div>
		
		<div class="block block-rounded">
			<div class="block-header">
				<div class="block-title"></div>
				<div class="block-options">
					<!-- <div class="input-group">
						<div class="input-group-prepend"><span class="input-group-text">Category</span></div>
						<select v-model="membership_level" class="form-select">
							<option value="ALL">ALL</option>
							<option value="SILVER">SILVER</option>
							<option value="GOLD">GOLD</option>
							<option value="DIAMOND">DIAMOND</option>
							<option value="PLATINUM">PLATINUM</option>
						</select>
					</div> -->
				</div>
			</div>
			<div class="block-content block-content-full">
				<!-- Pagination -->
				<pagination v-if="trcCouplesBlogs.data.length > 0" :collections="trcCouplesBlogs"/>
				<div class="table-responsive">
					<table class="table table-striped table-borderless table-hover table-vcenter">
						<thead>
							<tr>
								<th>TITLE</th>
								<th>IMAGE</th>
								<th>STATUS</th>
								<th nowrap="">DATE START</th>
								<th nowrap="">PUBLISHED DATE</th>
								<th>CREATED</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(blog, a_index) in trcCouplesBlogs.data"
								:key="blog.couple_blog_uuid"
							>
								<td>{{blog.blog_title}}</td>
								<td>
									<img :src="blog.blog_image_url" style="width: 50%" />
								</td>
								<td>
									<span v-if="blog.is_active==0" class="text-danger">OFF</span>
									<span v-if="blog.is_active==1" class="text-success">ON</span>
								</td>
								<td>{{blog.date_start_format}}</td>
								<td>{{blog.date_published_format}}</td>
								<td>{{blog.created_at_format}}</td>
								<td class="text-end">
									<button @click="viewTRCCoupleBlogModal(a_index,'update')" type="button" class="btn btn-sm btn-alt-info"><i class="fa fa-pencil-alt"></i></button>
									<button @click="confirmDelete(a_index)" type="button" class="btn btn-sm btn-alt-danger"><i class="fa fa-trash-alt"></i></button>
								</td>
							</tr>
							<tr v-if="trcCouplesBlogs.data.length <= 0">
								<td colspan="7" class="mb-0 fw-semibold text-center p-5">NO TRC COUPLES BLOGS FOUND.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="trcCouplesBlogs.data.length > 0" :collections="trcCouplesBlogs"/>
			</div>
		</div>
		<AddUpdateTRCCoupleBlogModal ref="addUpdateTRCCoupleBlogModal" />

		<modal ref="modalDelete" size="modal-lg">
			<template #title>DELETE CONFIRM</template>
			<template #body>
				<p>Are you sure, you want to delete this content?</p>
			</template>
			<template #footer>
				<button 
					@click="deleteTRCCoupleBlog"
					type="submit"
					class="btn btn-alt-danger"
					:disabled="formDelete.processing"
				>
					<span v-if="!formDelete.processing"><i class="fa fa-check me-2"></i>Yes</span>
						<span v-else>
							<div class="spinner-border spinner-border-sm text-dark" role="status" >
								<span class="sr-only mr-1">Please wait...</span>
							</div>
							<span class="mx-2">Please wait...</span>
						</span>
				</button>
				<button
					@click="modalDelete.toggleModal"
					type="button"
					class="btn btn-alt-secondary"
					:disabled="formDelete.processing"
				>
					<i class="fa fa-times me-2"></i>NO
				</button>
			</template>
		</modal>
	</div>
</template>

<script>
import { onMounted, watch, ref, reactive } from 'vue';
import { useForm } from '@inertiajs/inertia-vue3';
import AuthLayout from '../../../Layouts/AuthLayout';
import AddUpdateTRCCoupleBlogModal from '../../../Components/Admin/AddUpdateTRCCoupleBlogModal';
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia';

export default {
	layout: AuthLayout,
	props: {
		search				: String,
		trcCouplesBlogs		: Object,
		api_response 		: Object
	},
	components:{AddUpdateTRCCoupleBlogModal},
	setup(props) {

		const action = ref('add');

		const toast = createToaster();

		const selectedTRCCoupleBlog = reactive({});

		const form = useForm({
			search 	: props.search,
		});

		const formDelete = useForm({
			couple_blog_uuid 	: null,
			blog_image 		: null
		});

		const modalDelete 					= ref(null);
		const addUpdateTRCCoupleBlogModal 	= ref(null);

		const searchRecords = () => {

			Inertia.get(route('admin.trc-couples.blogs',{
					search 		: form.search
				})
			)
		}

		const viewTRCCoupleBlogModal = (_index,_action)=>{
			
			action.value = _action;
			
			if(_action=='update')
			{
				selectedTRCCoupleBlog.couple_blog_uuid 	= props.trcCouplesBlogs.data[_index].couple_blog_uuid;
				selectedTRCCoupleBlog.blog_title 			= props.trcCouplesBlogs.data[_index].blog_title;
				selectedTRCCoupleBlog.blog_tags 			= props.trcCouplesBlogs.data[_index].blog_tags;
				selectedTRCCoupleBlog.short_desc 			= props.trcCouplesBlogs.data[_index].short_desc;
				selectedTRCCoupleBlog.blog_desc 			= props.trcCouplesBlogs.data[_index].blog_desc;
				selectedTRCCoupleBlog.prev_blog_image 		= props.trcCouplesBlogs.data[_index].prev_blog_image;
				selectedTRCCoupleBlog.blog_image 			= props.trcCouplesBlogs.data[_index].blog_image;
				selectedTRCCoupleBlog.blog_image_url 		= props.trcCouplesBlogs.data[_index].blog_image_url;
				selectedTRCCoupleBlog.is_active 			= props.trcCouplesBlogs.data[_index].is_active;
				selectedTRCCoupleBlog.date_start 			= props.trcCouplesBlogs.data[_index].date_start;
				selectedTRCCoupleBlog.date_published 		= props.trcCouplesBlogs.data[_index].date_published;
			}

			addUpdateTRCCoupleBlogModal.value.setTrcCoupleBlog(_action,selectedTRCCoupleBlog);

			addUpdateTRCCoupleBlogModal.value.toggleModal();

		}

		const confirmDelete = (_index)=>{
			formDelete.couple_blog_uuid 		=  props.trcCouplesBlogs.data[_index].couple_blog_uuid;
			formDelete.blog_image 				=  props.trcCouplesBlogs.data[_index].blog_image;
			modalDelete.value.toggleModal();
		}

		const deleteTRCCoupleBlog = ()=>{
			action.value = 'delete';
			formDelete.delete('blogs/'+formDelete.couple_blog_uuid, {
				preserveState: true,
				preserveScroll: true,
				only:['trcCouplesBlogs,api_response'],
				onSuccess: () => {
					formDelete.reset();
					modalDelete.value.toggleModal();
				},
			})
		}

		// watch(membership_level, (value,old_value) => {
			
		// 	if(value!=old_value)
		// 	{
		// 		var param = {membership_level:value}

		// 		if(value=="null")
		// 		{
		// 			param = "";
		// 		}

		// 		Inertia.get(
		// 				'/admin/stock-updates', param,
		// 				{
		// 					// replace: true,
		// 					preserveState: true,
		// 					preserveScroll: true,
		// 					only: ['trcCouplesBlogs']
		// 				}
		// 			)
		// 	}
		// })

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action.value=='add' ? 'added' : (action.value=='delete' ? 'deleted' : 'updated');

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "danger"});
				}
			}
		})

		return{
			toast,
			action,
			form,
			formDelete,
			searchRecords,
			modalDelete,
			confirmDelete,
			deleteTRCCoupleBlog,
			selectedTRCCoupleBlog,
			viewTRCCoupleBlogModal,
			addUpdateTRCCoupleBlogModal
		}
	},
}
</script>
